<template>
  <v-layout row wrap pa-3>
    <v-flex xs12>
      Prepared items
    </v-flex>
    <v-flex>
      <list :items="filteredItems" view-type="bump-out"></list>
    </v-flex>
  </v-layout>
</template>
<script>
import List from "./list";

export default {
  components: { List },
  props: {
    filteredItems: {
      type: Array,
    },
  },
  data() {
    return {
    };
  }
};
</script>